export default __webpack_public_path__ + "static/media/fa-icon-32-dark.b338e5ed.svg";